<div class="bg-card-light dark:bg-card-dark p-6 rounded-xl border border-gray-200 dark:border-gray-800 shadow-sm">
  <h3 class="text-lg font-bold font-display text-gray-700 dark:text-white mb-4">
    Recently Uploaded Videos
  </h3>

  <!-- Loader -->
  <!-- <div *ngIf="isLoading" class="text-gray-500 dark:text-gray-400 text-sm py-4">
    Loading videos...
  </div> -->

  <!-- Dynamic Videos -->
  <div *ngIf="videos.length > 0" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
    <div *ngFor="let video of videos" class="group flex flex-col gap-2 cursor-pointer p-2 rounded-lg" (click)="openVideo(video)">
      <div class="relative w-full aspect-video rounded-lg overflow-hidden shadow-sm">
        <img
          [src]="video.thumbnail"
          [alt]="video.title"
          class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
        <div
          class="absolute inset-0 bg-black/20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span class="material-symbols-outlined text-white text-5xl">play_circle</span>
        </div>
      </div>
      <div>
        <p class="text-sm text-gray-700 dark:text-gray-300 group-hover:text-primary dark:group-hover:text-primary transition-colors truncate">
          <span class="font-semibold">{{ video.application }}:</span> {{ video.title }}
        </p>
        <p class="text-gray-500 dark:text-gray-400 text-xs">Uploaded {{ video.viewed }}</p>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="videos.length === 0" class="text-gray-500 dark:text-gray-400 text-sm py-4 text-center">
    No videos found.
  </div>
</div>
